export const LEGAL_EFFECTIVE_DATE = "2026-08-01";
export const TERMS_VERSION = "terms-2026-08-01";
export const PRIVACY_VERSION = "privacy-2026-08-01";
export const SUBPROCESSORS_VERSION = "subprocessors-2026-08-01";
export const SECURITY_VERSION = "security-2026-08-01";
export const LEGAL_CONTACT_EMAIL = "support@landagility.com";

